<template>
  <div class="badge" v-if="badge">
    <component :is="badge.icon" v-if="badge.icon" class="badge__icon" />
    <div class="badge__copy">{{ $t(`filter.${badge.translationKey}`) }}</div>
  </div>
</template>

<script>
import IconBolt from '@/components/_icons/IconBolt.svg'

const PRECEDENCE_ORDERED_BADGES = {
  new: { translationKey: 'new_arrivals', icon: IconBolt },
  lowStock: { translationKey: 'low_stock' },
}

export default {
  name: 'Badge',

  props: {
    badgeTypes: {
      type: Array,
      validator(badgeTypes) {
        return badgeTypes.every(type => Object.keys(PRECEDENCE_ORDERED_BADGES).includes(type))
      },
    },
  },

  data() {
    return {}
  },

  computed: {
    badge() {
      return PRECEDENCE_ORDERED_BADGES[
        Object.keys(PRECEDENCE_ORDERED_BADGES).find(type => this.badgeTypes.includes(type))
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.badge {
  font-size: $font-size-smaller;
  font-weight: bold;
  letter-spacing: 0.35em;
  color: $color-grey-dark-2;
  text-transform: uppercase;
  background-color: $color-white;
  padding-left: 2px;
  opacity: 0.85;

  &__copy {
    padding: 10px 9px 10px 12px;
    display: inline-block;
  }

  &__icon {
    position: relative;
    top: 6px;
    width: 22px;
    height: 22px;
    margin: 0 -13px 0 6px;
  }
}
</style>
